module.exports = __webpack_public_path__ + "img/Wp_2026.6a60f93a.png";